import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dc-pane',
  templateUrl: './dc-pane.component.html',
  styleUrls: ['./dc-pane.component.scss'],
})
export class DcPaneComponent implements OnInit {
  @Input() noPadding: boolean;
  @Input() headerSearch: boolean;
  @Input() tableContainer: boolean;
  @Input() noHeader: boolean;
  @Input() filters: boolean;
  @Input() loading: boolean;
  @Input() noScrollBar: boolean;
  @Input() noScroll: boolean;
  @Input() xScrollMinWidth: number; // number is px value of min width. To use, put an 'overflow-x: auto' style on the app-pane component where it is rendered
  @Input() lightBackground: boolean;
  @Input() lightBackgroundInnerBoxOnly: boolean;
  @Input() headerLinkRight: string;
  @Input() headerLinkRightDisabled: boolean;
  @Input() headerDateStringRight: string;
  @Input() downloadSection: boolean;
  @Input() class: string;
  @Output() headerLinkEmitter = new EventEmitter();

  constructor() {}
  ngOnInit(): void {}

  clickHeaderLinkRight(e) {
    this.headerLinkEmitter.emit(e);
  }
}
